import React from 'react';
import { Link } from 'react-router';

import BluecyberIcon from 'icons/bluecyber-icon.inline.svg';
import BluecyberWordMark from 'icons/bluecyber-wordmark.inline.svg';
import ActiveLinkIndicator from 'icons/active-link.inline.svg';

import styles from './navigation.scss';

export default function Navigation() {
  return (
    <nav className={styles.main}>
      <span className={styles.logo}>
        <BluecyberIcon className={styles.icon} />
        <BluecyberWordMark className={styles.wordmark} />
      </span>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Link
            to="/"
            className={styles.link}
            activeClassName={styles.activeLink}
            onlyActiveOnIndex
          >
            <ActiveLinkIndicator className={styles.corner} />
            Dashboard
            <ActiveLinkIndicator className={styles.corner} />
          </Link>
        </li>
        <li className={styles.item}>
          <Link to="/map/live" className={styles.link} activeClassName={styles.activeLink}>
            <ActiveLinkIndicator className={styles.corner} />
            Live Map
            <ActiveLinkIndicator className={styles.corner} />
          </Link>
        </li>
      </ul>
    </nav>
  );
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js